import React from "react";
import { StyledNotification } from "../../dashboard.style";
import ProgressBar from "./ProgressBar";
import { StyledInnerProgressBarNotification } from "../notifications.style";

const ProgressBarNotification = ({ show = true, content, type }) => {
	if (show) {
		return (
			<StyledNotification type={type}>
				<StyledInnerProgressBarNotification>
					<h3>{content.title}</h3>
					<p>{content.massage}</p>
					<ProgressBar sessionsAnalyzed={content.sessionsAnalyzed} type={type} maxSessions={content.maxSessions} />
				</StyledInnerProgressBarNotification>
			</StyledNotification>
		);
	} else return null;
};

export default ProgressBarNotification;
